<form [formGroup]="form" class="p-2">
	<div class="row mb-3">
		<div class="col-md-6">
			<nz-form-item>
				<nz-form-label nzFor="dateFrom">From</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="startDate" nzFormat="yyyy-MM-dd">
					</nz-date-picker>
				</nz-form-control>
			</nz-form-item>
		</div>

		<div class="col-md-6">
			<nz-form-item>
				<nz-form-label nzFor="dateTo">To</nz-form-label>
				<nz-form-control>
					<nz-date-picker formControlName="endDate" nzFormat="yyyy-MM-dd"
						[nzDisabledDate]="disabledEndDate">
					</nz-date-picker>
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>

	<div class="form-group mb-4">
		<label nz-checkbox formControlName="includeSummary">
			Include Summary (graphs &amp; tables)
		</label>
	</div>

	<div class="text-end">
		<button nz-button nzType="default" (click)="handleCancel()" [disabled]="running">Cancel</button>
		<button nz-button nzType="primary" (click)="handleDownload()" [disabled]="form.invalid || running">
			<ng-container *ngIf="running">Running...</ng-container>
			<ng-container *ngIf="!running">Download</ng-container>
		</button>
	</div>
</form>